import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AppTilesModule } from '../app-tiles/app-tiles.module';
import { DocumentsModule } from '../documents/documents.module';
import { FoldersModule } from '../folders/folders.module';
import { LazyViewModule } from '../lazy-view/lazy-view.module';
import { InstrumentationModule } from '../shared/instrumentation/instrumentation.module';
import { SharePointModule } from '../sharepoint/sharepoint.module';
import { HomeComponent } from './home.component';

@NgModule({
    imports: [
        AppTilesModule,
        CommonModule,
        FoldersModule,
        InstrumentationModule,
        LazyViewModule,
        SharePointModule,
        DocumentsModule
    ],
    declarations: [
        HomeComponent
    ]
})
export class HomeModule {
}
